module.exports = __webpack_public_path__ + "img/FILTER.1fe5dcad.svg";